<template>
  <form v-if="organization">
    <div class="row">
      <div class="col-md-2 text-right">
        <h6 class="underline">{{ 'organization' | t }}</h6>
      </div>
      <div class="col-md-8">
        <div class="card mb-5">
          <div class="card-body">
            <div class="form-group">
              <label>{{ 'name' | t }}</label>
              <input class="form-control" v-model="organization.name" />
            </div>
            <div class="form-group">
              <label>{{ 'custom_script' | t }}</label>
              <textarea class="form-control" v-model="organization.custom_script"></textarea>
            </div>
            <div class="form-group">
              <label>{{ 'custom_style' | t }}</label>
              <textarea class="form-control" v-model="organization.custom_style"></textarea>
            </div>
            <div class="form-check">
              <input class="form-check-input" v-model="organization.is_managed" type="checkbox" disabled="disabled" />
              <label class="form-check-label">Is whitelabel</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" v-model="organization.is_webshipper_supported" type="checkbox" />
              <label class="form-check-label">Is supported by Webshipper</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" v-model="organization.disable_price_quoting" type="checkbox" />
              <label class="form-check-label">Disable price quoting</label>
            </div>
            <div class="form-group" v-if="organization.is_managed">
              <label>{{ 'ssl_certificate_frontend' | t }}</label>
              <p class="text-muted">{{ 'ssl_explainer' | t }}</p>
              <textarea class="form-control" v-model="organization.ssl_certificate_frontend" rows="10"></textarea>
            </div>
            <div class="form-group" v-if="organization.is_managed">
              <label>{{ 'ssl_certificate_api' | t }}</label>
              <p class="text-muted">{{ 'ssl_explainer' | t }}</p>
              <textarea class="form-control" v-model="organization.ssl_certificate_api" rows="10"></textarea>
            </div>
            <div class="form-group">
              <label>{{ 'tos_url' | t }}</label>
              <input class="form-control" v-model="organization.tos_url" />
            </div>
            <div class="form-group">
              <label>{{ 'user_invite_mail_template' | t }}</label>
              <select class="form-control" v-model="organization.user_invite_mail_template">
                <option :value="null">{{ 'user_invite_mail_template_use_system_default' | t }}</option>
                <option
                  v-for="mail_template in mail_templates"
                  :value="mail_template"
                  :key="mail_template.id"
                  :selected="
                    organization.user_invite_mail_template &&
                    mail_template.id == organization.user_invite_mail_template.id
                  "
                >
                  {{ mail_template.name }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label>{{ 'user_forgot_password_mail_template' | t }}</label>
              <select class="form-control" v-model="organization.user_forgot_password_mail_template">
                <option :value="null">{{ 'user_invite_mail_template_use_system_default' | t }}</option>
                <option
                  v-for="mail_template in mail_templates"
                  :value="mail_template"
                  :key="mail_template.id"
                  :selected="
                    organization.user_forgot_password_mail_template &&
                    mail_template.id == organization.user_forgot_password_mail_template.id
                  "
                >
                  {{ mail_template.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="card mb-3">
          <div class="card-body">
            <div class="form-group">
              <label>{{ 'accounting_adapter' | t }}</label>
              <input class="form-control" v-model="organization.accounting_adapter" />
            </div>
          </div>
        </div>
        <div class="mb-5">
          <global-attrs v-model="organization.global_attrs" />
        </div>
        <div class="card mb-5">
          <div class="card-body">
            <div class="form-group" v-if="!organization.id">
              <label>{{ 'vat_no' | t }}</label>
              <input class="form-control" v-model="organization.vat_no" />
            </div>
            <div class="form-group" v-if="!organization.id">
              <label>{{ 'country_code' | t }}</label>
              <select class="form-control" v-model="organization.country_code">
                <option value="DK">Denmark</option>
                <option value="NO">Norway</option>
                <option value="SE">Sweden</option>
                <option value="NL">Netherlands</option>
                <option value="BE">Belgium</option>
                <option value="FI">Finland</option>
                <option value="GB">UK</option>
              </select>
            </div>
            <div class="form-group">
              <label>{{ 'contact_name' | t }}</label>
              <input class="form-control" v-model="organization.contact_name" />
            </div>
            <div class="form-group">
              <label>{{ 'contact_email' | t }}</label>
              <input class="form-control" v-model="organization.contact_email" />
            </div>
            <div class="form-group">
              <label>{{ 'contact_phone' | t }}</label>
              <input class="form-control" v-model="organization.contact_phone" />
            </div>
          </div>
        </div>
        <div class="card mb-5">
          <div class="card-body">
            <div class="form-group">
              <label>{{ 'logo' | t }}</label>
              <file-upload-collapsed v-model="organization.logo" type="image" />
            </div>
            <div class="form-group">
              <label>{{ 'icon' | t }}</label>
              <file-upload-collapsed v-model="organization.icon" type="image" />
            </div>
          </div>
        </div>
        <sweet-modal ref="show_agreement_modal">
          <div class="embed-responsive embed-responsive-1by1">
            <iframe class="embed-responsive-item" :src="dpa_base64"></iframe>
          </div>
        </sweet-modal>
        <div class="card mb-5">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label>{{ 'version' | t }}</label>
                  <input class="form-control" type="number" step="0.1" v-model="new_dpa.version" />
                </div>
                <div class="form-group">
                  <label>{{ 'pdf' | t }}</label>
                  <file-upload-collapsed v-model="new_dpa.pdf_data" />
                </div>
                <div class="form-group">
                  <label>{{ 'language' | t }}</label>
                  <select class="form-control" v-model="new_dpa.locale">
                    <option v-for="l in languages" :value="l.code" :key="l.code">{{ l.full_name }}</option>
                  </select>
                </div>
                <div class="form-group">
                  <button class="btn btn-success" @click="save_new_data_processing_agreement">{{ 'add' | t }}</button>
                </div>
              </div>
            </div>
            <table class="table ws-100">
              <thead>
                <tr>
                  <th>{{ 'active' | t }}</th>
                  <th>{{ 'version' | t }}</th>
                  <th>{{ 'pdf' | t }}</th>
                  <th class="w-25">{{ 'language' | t }}</th>
                  <th class="w-25">
                    <p class="text-muted">{{ 'requires_reapproval_description' | t }}</p>
                    <p>{{ 'requires_reapproval' | t }}</p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="dpa in dpas">
                  <td>
                    <input
                      class="form-check-input"
                      v-model="dpa.active"
                      type="checkbox"
                      @change="update_data_processing_agreement(dpa)"
                    />
                  </td>
                  <td>{{ dpa.version }}</td>
                  <td>
                    <button class="btn btn-primary" @click="spin($event, show_agreement_pdf, dpa)">
                      {{ 'open_pdf' | t }}
                    </button>
                  </td>
                  <td>
                    <label>{{ dpa.locale }}</label>
                  </td>
                  <td>
                    <input
                      class="form-check-input"
                      v-model="dpa.requires_customer_approval"
                      type="checkbox"
                      @change="update_data_processing_agreement(dpa)"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import Api from '@/store/jsonapi';
import _ from 'lodash';

export default {
  props: ['organization', 'organization_id'],
  data: function () {
    return {
      mail_templates: [],
      dpas: [],
      new_dpa: {},
      dpa_base64: '',
      languages: []
    };
  },
  methods: {
    async show_agreement_pdf(dpa) {
      await Api.find('data_processing_agreements', dpa.id, {
        fields: { data_processing_agreements: 'base64' }
      }).then(({ data }) => {
        this.dpa_base64 = 'data:application/pdf;base64,' + data.base64;
        this.$refs.show_agreement_modal.open();
      });
    },
    async save_new_data_processing_agreement() {
      this.new_dpa.pdf_data = this.new_dpa.pdf_data.replace('data:application/pdf;base64,', '');
      await Api.create('data_processing_agreements', {
        ...this.new_dpa,
        organization: this.organization
      }).then(({ data }) => {
        this.dpas.push(data);
        this.new_dpa = {};
      });
    },
    async update_data_processing_agreement(dpa) {
      await Api.update('data_processing_agreements', _.pick(dpa, ['active', 'id', 'requires_customer_approval'])).then(
        ({ data }) => {
          Alers.success({ title: 'Data processing agreement updated' });
        }
      );
    }
  },
  async mounted() {
    let { data: mail_templates } = await Api.findAllPages('mail_templates', {
      fields: { mail_templates: 'id,name' }
    });
    if (this.organization_id) {
      let { data: dpas } = await Api.findAllPages('data_processing_agreements', {
        filter: { organization_id: this.organization_id }
      });
      this.dpas = dpas;
    }

    this.mail_templates = mail_templates;

    this.languages = [
      { code: 'da', full_name: 'Denmark' },
      { code: 'nl', full_name: 'Netherlands' },
      { code: 'se', full_name: 'Sweden' },
      { code: 'en', full_name: 'UK' }
    ];
  }
};
</script>
